var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { getRelativeParent, isNodeOverlapped } from '../utils/node';
export var HighlighterContainerTag = 'KONTENT-SMART-LINK-OVERLAY';
export var HighlighterElementTag = 'KONTENT-SMART-LINK-ELEMENT';

var HighlightRenderer =
/** @class */
function () {
  function HighlightRenderer() {
    var _this = this;

    this.destroy = function () {
      _this.clear();

      _this.defaultContainer.remove();
    };

    this.selectNode = function (node) {
      var highlight = _this.highlightByNode.get(node);

      if (highlight) {
        node.classList.add('kontent-smart-link__node--selected');
        highlight.classList.add('selected');
      }
    };

    this.deselectNode = function (node) {
      var highlight = _this.highlightByNode.get(node);

      if (highlight) {
        node.classList.remove('kontent-smart-link__node--selected');
        highlight.classList.remove('selected');
      }
    };

    this.render = function (nodes) {
      var e_1, _a, e_2, _b, e_3, _c;

      var _d;

      if (nodes.size === 0) {
        _this.clear();
      } else {
        var newHighlightByNode = new Map();

        try {
          for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var node = nodes_1_1.value;
            var nodeRect = node.getBoundingClientRect();
            var isOverlapped = isNodeOverlapped(node, nodeRect); // This check is needed to prevent highlight rendering for the "flat" elements (height or/and width === 0),
            // because those elements are basically invisible and cannot be clicked.

            var isFlat = nodeRect.height === 0 || nodeRect.width === 0;

            if (!isOverlapped && !isFlat) {
              var parent_1 = getRelativeParent(node);
              var highlight = (_d = _this.highlightByNode.get(node)) !== null && _d !== void 0 ? _d : _this.createHighlight(parent_1);

              if (parent_1) {
                var parentRect = parent_1.getBoundingClientRect();
                highlight.style.top = nodeRect.top - parentRect.top + "px";
                highlight.style.left = nodeRect.left - parentRect.left + "px";
              } else {
                highlight.style.top = nodeRect.top + window.pageYOffset + "px";
                highlight.style.left = nodeRect.left + window.pageXOffset + "px";
              }

              highlight.style.width = nodeRect.width + "px";
              highlight.style.height = nodeRect.height + "px";
              newHighlightByNode.set(node, highlight);

              _this.highlightByNode.delete(node);
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }

        try {
          for (var _e = __values(_this.highlightByNode.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
            var _g = __read(_f.value, 2),
                node = _g[0],
                highlight = _g[1];

            highlight.remove();

            _this.highlightByNode.delete(node);
          }
        } catch (e_2_1) {
          e_2 = {
            error: e_2_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_2) throw e_2.error;
          }
        }

        try {
          for (var _h = __values(_this.containerByParent.entries()), _j = _h.next(); !_j.done; _j = _h.next()) {
            var _k = __read(_j.value, 2),
                parent_2 = _k[0],
                container = _k[1];

            if (container.children.length === 0) {
              container.remove();

              _this.containerByParent.delete(parent_2);
            }
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
          } finally {
            if (e_3) throw e_3.error;
          }
        }

        _this.highlightByNode = newHighlightByNode;
      }
    };

    this.clear = function () {
      var e_4, _a, e_5, _b;

      try {
        for (var _c = __values(_this.highlightByNode.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
          var _e = __read(_d.value, 2),
              node = _e[0],
              highlight = _e[1];

          highlight.remove();

          _this.highlightByNode.delete(node);
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_4) throw e_4.error;
        }
      }

      try {
        for (var _f = __values(_this.containerByParent.entries()), _g = _f.next(); !_g.done; _g = _f.next()) {
          var _h = __read(_g.value, 2),
              parent_3 = _h[0],
              container = _h[1];

          container.remove();

          _this.containerByParent.delete(parent_3);
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        } finally {
          if (e_5) throw e_5.error;
        }
      }

      _this.highlightByNode = new Map();
      _this.containerByParent = new Map();
      _this.defaultContainer.innerHTML = '';
    };

    this.createHighlight = function (parent) {
      var highlight = document.createElement(HighlighterElementTag);

      var container = _this.createContainerIfNotExist(parent);

      container.appendChild(highlight);
      return highlight;
    };

    this.createContainerIfNotExist = function (parent) {
      if (!parent) {
        return _this.defaultContainer;
      }

      if (_this.containerByParent.has(parent)) {
        return _this.containerByParent.get(parent);
      }

      var container = document.createElement(HighlighterContainerTag);
      parent.appendChild(container);

      _this.containerByParent.set(parent, container);

      return container;
    };

    this.containerByParent = new Map();
    this.highlightByNode = new Map();
    this.defaultContainer = HighlightRenderer.createDefaultContainer();
  }

  HighlightRenderer.createDefaultContainer = function () {
    var container = document.createElement(HighlighterContainerTag);
    window.document.body.appendChild(container);
    return container;
  };

  return HighlightRenderer;
}();

export { HighlightRenderer };